import environmentApi from "../api/environment.api";
import { AxiosResponse } from "axios";
import { FeatureFlagsAndDynamicConfiguration } from "../types/FeatureFlagsAndDynamicConfiguration";
import businessPortalClient from "../businessPortalClient";

type EnvironmentService = {
  getEnvironment: () => Promise<AxiosResponse<string>>;
  getVersion: () => Promise<AxiosResponse<string>>;
  getPortalStatus: () => Promise<AxiosResponse<boolean>>;
  getFeatureFlagsAndDynamicConfiguration: (
    loggedInCrmId: string
  ) => Promise<AxiosResponse<FeatureFlagsAndDynamicConfiguration>>;
  getAllowImpersonation: (
    loggedInCrmId: string
  ) => Promise<AxiosResponse<boolean>>;
  getCountryCodeByCrmId: (
    crmId: string
  ) => Promise<AxiosResponse<string>>;
};

const getEnvironment = (): Promise<AxiosResponse<string>> =>
  businessPortalClient.get(environmentApi.getEnvironmentUrl());

const getVersion = (): Promise<AxiosResponse<string>> =>
  businessPortalClient.get(environmentApi.getVersionUrl());

const getPortalStatus = (): Promise<AxiosResponse<boolean>> =>
  businessPortalClient.get(environmentApi.getPortalStatusUrl());

const getFeatureFlagsAndDynamicConfiguration = (loggedInCrmId: string): Promise<AxiosResponse<FeatureFlagsAndDynamicConfiguration>> =>
  businessPortalClient.get(environmentApi.getFeatureFlagsAndDynamicConfigurationUrl(loggedInCrmId));

const getAllowImpersonation = (
  loggedInCrmId: string
): Promise<AxiosResponse<boolean>> =>
  businessPortalClient.get(environmentApi.getAllowImpersonationUrl(loggedInCrmId));

const getCountryCodeByCrmId = (
  crmId: string
): Promise<AxiosResponse<string>> =>
  businessPortalClient.get(environmentApi.getCountryCodeByCrmIdUrl(crmId));

export default {
  getEnvironment,
  getVersion,
  getPortalStatus,
  getFeatureFlagsAndDynamicConfiguration,
  getAllowImpersonation,
  getCountryCodeByCrmId,
} as EnvironmentService;
